import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/buttons/BeosButtonDemo.vue"),
  },
  {
    path: "/icon-button",
    component: () => import("../views/buttons/BeosIconButtonDemo.vue"),
  },
  {
  path: '/inputs',
  name: 'BeosInput',
  component: () => import("../views/inputs/BeosInputDemo.vue"),
},
{
  path: '/autocomplete',
  name: 'BeosAutocomplete',
  component: () => import("../views/autocomplete/BeosAutocompleteDemo.vue"),
},
{
  path: '/checkbox',
  name: 'BeosCheckbox',
  component: () => import("../views/checkbox/BeosCheckboxDemo.vue"),
},
{
  path: '/chip',
  name: 'BeosChip',
  component: () => import("../views/chip/BeosChipDemo.vue"),
},
{
  path: '/radio',
  name: 'BeosRadioButton',
  component: () => import("../views/radio/BeosRadioDemo.vue"),
},
{
  path: '/switch',
  name: 'BeosSwitchButton',
  component: () => import("../views/switch/BeosSwitchDemo.vue"),
},
{
  path: '/chip-list',
  name: 'BeosChipList',
  component: () => import("../views/chipList/BeosChipListDemo.vue"),
},
{
  path: '/progress-linear',
  name: 'BeosProgressLinear',
  component: () => import("../views/progress/BeosProgressLinearDemo.vue"),
},
{
  path: '/progress-circular',
  name: 'BeosProgressCircular',
  component: () => import("../views/progress/BeosProgressCircularDemo.vue"),
},
{
  path: '/avatar',
  name: 'BeosAvatar',
  component: () => import("../views/avatar/BeosAvatarDemo.vue"),
},
{
  path: '/list',
  name: 'BeosList',
  component: () => import("../views/list/BeosListDemo.vue"),
},
{
  path: '/form-dialog',
  name: 'BeosFormDialog',
  component: () => import("../views/formDialog/BeosFormDialogDemo.vue"),
},
{
  path: '/tooltip',
  name: 'BeosTooltip',
  component: () => import("../views/tooltip/BeosTooltipDemo.vue"),
},
{
  path: '/table',
  name: 'BeosTable',
  component: () => import("../views/table/BeosTableDemo.vue"),
},
{
  path: '/menu',
  name: 'BeosMenu',
  component: () => import("../views/menu/BeosMenuDemo.vue"),
},
  {
    path: '/icon',
    name: 'BeosIcon',
    component: () => import("../views/icon/BeosIconDemo.vue"),
  },
{
  path: '/toolbar',
  name: 'BeosToolbar',
  component: () => import("../views/toolbar/BeosToolbarDemo.vue"),
},
  {
    path: '/image',
    name: 'BeosImg',
    component: () => import("../views/img/BeosImgDemo.vue"),
  },
  {
    path: '/expansion-panel',
    name: 'BeosExpansionPanels',
    component: () => import("../views/expansionPanel/BeosExpansionPanelDemo.vue"),
  },
  {
    path: '/icons/catalog',
    name: 'IconCatalog',
    component: () => import('../views/icon/BeosIconCatalog.vue')
  },
  {
    path: '/tabs',
    name: 'BeosTabs',
    component: () => import('../views/tabs/BeosTabsDemo.vue')
  },
  // Always leave this as last one,
  // but you can also remove it
];

const router = new VueRouter({
  routes,
});

export default router;
